import { Icon } from '@eneco/sparky/icons';
import { styled } from '@eneco/sparky/stitches';
import * as Dialog from '@radix-ui/react-dialog';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';

export { Dialog };
export { NavigationMenu };

export const StyledNavigationMenuContentDesktop = styled(NavigationMenu.Content, {
  position: 'absolute',
  right: 0,
  left: 0,
  marginTop: '$1',
  boxShadow: '$m',
  zIndex: 3,
});

export const StyledDialogContentMobile = styled(Dialog.Content, {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
});

export const StyledTrigger = styled(Dialog.Trigger, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '$2',

  cursor: 'pointer',
  background: 'none',
  border: 'none',
  paddingX: 0,

  backgroundImage: 'linear-gradient($colors$navLinkUnderline, $colors$navLinkUnderline)',
  backgroundPosition: '0 100%',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '0% 2px',
  transition: 'background-size 0.3s ease',

  typography: '$bodyL',
  fontWeight: '$bodyBold',
  color: '$colors$linkPrimary',

  '&:hover, &:active': {
    color: '$colors$navLinkBrand',
    backgroundImage: 'linear-gradient($colors$navLinkUnderline, $colors$navLinkUnderline)',
    backgroundSize: '100% 2px',
  },
  [`&:hover ${Icon}`]: {
    fill: '$colors$navLinkBrand',
  },
});

export const StyledNavigationMenuTriger = styled(NavigationMenu.Trigger, StyledTrigger, {
  '&[data-state="open"]': {
    color: '$colors$navLinkBrand',
    [`${Icon}`]: {
      fill: '$colors$navLinkBrand',
      transform: 'rotate(180deg)',
    },
  },
});

export const BackButton = styled('button', {
  display: 'flex',
  gap: '$8',
  alignItems: 'center',
  color: '$colors$linkBrand',
  typography: '$bodyL',
  fontWeight: '$bodyBold',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  '&:hover, &:active': {
    color: '$colors$linkPrimary',
  },
});

export const NavigationMenuWrapper = styled('div', {
  /*  Resets positioning set on a div that's automatically added by Radix when using the NavigationMenu.List */
  '& nav > div': {
    position: 'initial !important',
  },
});
